import React from 'react';
import { motion } from 'framer-motion';
import './SectionHeader.css';

/**
 * Shared header for every section: small eyebrow label, a display-font title whose last
 * word carries the accent gradient, and a subtitle. Extra props (initial, whileInView,
 * variants, ...) go straight to the motion wrapper so each section keeps its own entrance.
 */
const SectionHeader = ({ eyebrow, lead, accent, subtitle, ...motionProps }) => (
  <motion.div className="sh" {...motionProps}>
    <p className="sh-eyebrow">
      <span aria-hidden="true" />
      {eyebrow}
    </p>
    <h2 className="sh-title">
      {lead} <span className="sh-accent">{accent}</span>
    </h2>
    {subtitle && <p className="sh-subtitle">{subtitle}</p>}
  </motion.div>
);

export default SectionHeader;
